import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  getNotationCompare,
  getNotationHeaderCompare
} from '../../../../actions/notes';

import LineGraph from '../../../../components/Charts/LineGraph';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import Select from '../../../../components/Select';
import SelectFilter from '../../../../components/Select/SelectFilter';
import ExportButton from '../../../../components/Export';
import get from 'lodash/get';
import Spinner from '../../../../components/Spinner';
import { I18n } from 'react-redux-i18n';

const Container = styled.div`
  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }
  .rightComponentsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    > :not(:last-child) {
      margin-right: 15px;
    }
  }
  .selectSetsContainer {
    margin-top: 50px;
    width: 40%;
    margin-left: 30%;
  }
  .setListContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    margin-top: 5px;

    > div {
      margin: 0 !important;
      height: 30px !important;
      white-space: nowrap !important;
      width: initial !important;
    }
    .tag {
      width: initial !important;
    }
    > div:not(:last-child) {
      margin-right: 10px !important;
    }
  }
  .compareHistoryChartContainer {
    margin-top: 40px;
  }

  .filterContainer {
    margin-bottom: 40px;
    background-color: rgba(173, 181, 189, 0.05);
    padding: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 20px;
  }

  .recharts-cartesian-axis-tick-value {
    font-size: 12px !important;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    fill: ${(props) => props.theme.colors.dark};
  }
`;

class PreparationLineGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rank: null,
      appellation: null,
      wine: null,
      hoverExport: false,
      loading: true,
      tagList: [],
      forceCloseMenu: false
    };
  }

  async componentDidMount() {
    await this.props.getNotationHeaderCompare();
    await this.props.getNotationCompare();
    this.setState({ loading: false });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps != this.props &&
      this.props.headerCompare.client_wines &&
      this.props.headerCompare.client_wines.length > 0
    ) {
      this.setState({
        wine: {
          label: get(this.props, 'headerCompare.client_wines[0].wine_name'),
          value: get(this.props, 'headerCompare.client_wines[0].wine_name')
        },
        journalist: {
          value: 'wxr_primeur',
          label: 'WXR'
        }
      });
    }
  }

  formatData() {
    const all_notes = this.props.data.all_notes || [];
    let wxr_notes = this.props.data.wxr_notes || [];
    let aggregatedNotes = [];
    for (let note of all_notes) {
      let currentComboIndex = aggregatedNotes.findIndex(
        (item) =>
          item.wine_name === note.wine_name && item.vintage === note.vintage
      );
      if (currentComboIndex >= 0 && aggregatedNotes[currentComboIndex]) {
        let currentData = aggregatedNotes[currentComboIndex];
        if (note.note_type === 'Primeur') {
          currentData[note.journalist_short_name + '_primeur'] =
            note.normalized_note_filtered;
          currentData[note.journalist_short_name + '_rawPrimeur'] =
            note.note_filtered;
          currentData[note.journalist_short_name + '_rawPrimeurFloat'] =
            note.float_note_filtered;
        } else {
          if (!currentData[note.journalist_short_name + '_note']) {
            currentData[note.journalist_short_name + '_note'] =
              note.normalized_note_filtered;
            currentData[note.journalist_short_name + '_rawNote'] =
              note.note_filtered;
            currentData[note.journalist_short_name] = note;
          }
        }
        if (!currentData[note.journalist_short_name + '_note']) {
          currentData[note.journalist_short_name + '_note'] = '-';
        }
        if (!currentData[note.journalist_short_name + '_rawNote']) {
          currentData[note.journalist_short_name + '_rawNote'] = '-';
        }
        if (!currentData[note.journalist_short_name + '_allnotes']) {
          currentData[note.journalist_short_name + '_allnotes'] = [note];
        } else {
          currentData[note.journalist_short_name + '_allnotes'].push(note);
        }
      } else {
        aggregatedNotes.push({
          wine_name: note.wine_name,
          vintage: note.vintage,

          [note.journalist_short_name + '_allnotes']: [note],
          [note.journalist_short_name + '_note']:
            note.note_type !== 'Primeur' ? note.normalized_note_filtered : '-',

          [note.journalist_short_name + '_rawNote']:
            note.note_type !== 'Primeur' ? note.note_filtered : '-',
          [note.journalist_short_name]: note,
          [note.journalist_short_name + '_primeur']:
            note.note_type === 'Primeur' ? note.normalized_note_filtered : null,
          [note.journalist_short_name + '_rawPrimeur']:
            note.note_type === 'Primeur' ? note.note_filtered : '-',
          [note.journalist_short_name + '_rawPrimeurFloat']:
            note.note_type === 'Primeur' ? note.float_note_filtered : '-'
        });
      }
    }
    wxr_notes.forEach((note) => {
      let currentComboIndex = aggregatedNotes.findIndex(
        (item) =>
          item.wine_name === note.wine_name && item.vintage === note.vintage
      );
      if (currentComboIndex >= 0) {
        aggregatedNotes[currentComboIndex] = {
          ...aggregatedNotes[currentComboIndex],
          wxr_note: note.wxr ? note.wxr.toFixed(2) : 0,
          wxr_primeur: note.wxr_primeur ? note.wxr_primeur.toFixed(2) : 0,
          appellation_name: note.appelation_name,
          classement_name: note.classement_name
        };
      } else {
        aggregatedNotes.push({
          wine_name: note.wine_name,
          vintage: note.vintage,
          wxr_note: note.wxr ? note.wxr.toFixed(2) : 0,
          appellation_name: note.appelation_name,
          classement_name: note.classement_name,
          wxr_primeur: note.wxr_primeur ? note.wxr_primeur.toFixed(2) : 0
        });
      }
    });
    return aggregatedNotes;
  }

  filterData(formattedData) {
    let filteredData = [...formattedData];
    const { wine, rank, appellation } = this.state;
    filteredData = wine
      ? filteredData.filter((item) => item.wine_name === wine.value)
      : filteredData.filter(
          (item) => item.wine_name === filteredData[0].wine_name
        );
    filteredData = rank
      ? filteredData.filter((item) => item.classement_name === rank.value)
      : filteredData;
    filteredData = appellation
      ? filteredData.filter(
          (item) => item.appellation_name === appellation.value
        )
      : filteredData;
    return filteredData;
  }

  formatRivals(data) {
    const client_wines = this.props.headerCompare.client_wines || [];
    const rivalsFormatted = {};
    data.forEach((wineFormatted) => {
      const isClientWine = client_wines.find(
        (item) => item.wine_name === wineFormatted.wine_name
      );
      if (!isClientWine) {
        let wineClient = null;
        client_wines.forEach((wine) => {
          const rival = wine.rivals.find(
            (item) => item === wineFormatted.wine_name
          );
          if (rival) {
            wineClient = wine.wine_name;
          }
        });
        if (!rivalsFormatted[wineClient]) {
          rivalsFormatted[wineClient] = [wineFormatted];
        } else {
          rivalsFormatted[wineClient].push(wineFormatted);
        }
      }
    });
    return rivalsFormatted;
  }

  removeRivals(formattedData) {
    const client_wines = this.props.headerCompare.client_wines || [];
    return formattedData.filter((wineFormatted) => {
      const isClientWine = client_wines.find(
        (item) => item.wine_name === wineFormatted.wine_name
      );
      return isClientWine;
    });
  }

  renderCardHeader() {
    const { wine } = this.state;
    return (
      <CardHeader
        title={I18n.t('primeur.compare.lineChart.title')}
        fontSize="20px"
        iconRight
        rightComponents={
          <ExportButton
            jpg
            pdf
            xls
            path="/api/v1/clients/me/primeur/notation/xls/"
            options={{
              wine: wine ? wine.label : ''
            }}
            colors={['#e25d34', '#1f2b37', '#a5aaaf', '#B1B7BD', '#C9D0D6']}
            name="evolution-note-primeur"
            targetElement="#evolution-note-primeur"
          />
        }
      />
    );
  }

  renderSelectSets(rivals) {
    const { journalist } = this.state;
    if (journalist && journalist.value != 'wxr_primeur') {
      rivals = rivals.filter((item) => item[journalist.value + '_primeur']);
    }
    return (
      <div className="selectSetsContainer ignored-export">
        <Select
          placeholder={I18n.t('placeholderRivals')}
          minWidth="250px"
          isMulti
          value={this.state.tagList}
          dropdownProps={{
            styles: `margin-left:20px;margin-right:20px;`
          }}
          onChange={(value) =>
            value.length > 5
              ? this.setState({ tagList: value.slice(1, value.length) })
              : this.setState({ tagList: value })
          }
          options={
            rivals && rivals.length > 0
              ? [...new Set(rivals.map((item) => item.wine_name))].map(
                  (item) => ({
                    value: item,
                    label: item
                  })
                )
              : []
          }
        />
      </div>
    );
  }

  formatSet(data) {
    const { journalist } = this.state;
    let formattedData = [];
    if (data.length > 0) {
      data.forEach((wine) => {
        let value = 0;
        let raw = 0;
        if (journalist && journalist.label !== 'WXR') {
          value =
            journalist.value === 'CK' ||
            journalist.value === 'JMQ' ||
            journalist.value === 'RVF'
              ? wine[journalist.value + '_primeur']
              : wine[journalist.value + '_rawPrimeurFloat'];
          raw = wine[journalist.value + '_rawPrimeur'];
        }
        if (journalist && journalist.label === 'WXR') {
          value = wine.wxr_primeur;
          raw = wine.wxr_primeur;
        }
        if (!value || isNaN(value)) {
          value = 0;
          raw = 0;
        }
        if (value != 0) {
          formattedData.push({
            value,
            raw,
            name: wine.vintage,
            wine: wine.wine_name
          });
        }
      });
    }

    return formattedData;
  }

  formatDataChart(data, rivals) {
    let { tagList } = this.state;
    let formattedData = [data];
    let rivalsSet = [];
    tagList
      .map((item) => item.label)
      .forEach((tag) => {
        const set = rivals.filter((item) => item.wine_name === tag);
        rivalsSet.push(set);
      });
    formattedData.push(...rivalsSet);
    formattedData = [...formattedData.map((set) => this.formatSet(set))];

    let names = [...formattedData.map((set) => set.map((item) => item.name))];
    names = [].concat.apply([], names);
    names = [...new Set(names)].sort();
    formattedData.forEach((set) => {
      names.forEach((item, index) => {
        if (!set[index] || item !== set[index].name) {
          set.splice(index, 0, {
            name: names[index],
            value: null
          });
        }
      });
    });
    return formattedData;
  }

  getOptions(data) {
    const { wine } = this.state;
    const wineOption = [...new Set(data.map((item) => item.wine_name))].map(
      (item) => ({
        value: item,
        label: item
      })
    );

    const rankOptions = [
      ...new Set(data.map((item) => item.classement_name))
    ].map((item) => ({
      value: item,
      label: item
    }));

    const appellationOptions = [
      ...new Set(data.map((item) => item.appellation_name))
    ].map((item) => ({
      value: item,
      label: item
    }));

    let journalistOptions = [
      {
        value: 'wxr_primeur',
        label: 'WXR'
      }
    ];
    data = wine ? data.filter((item) => item.wine_name === wine.label) : [];

    if (data && data.length > 0) {
      data.forEach((wine) => {
        Object.keys(wine).forEach((key) => {
          if (
            key.includes('_allnotes') &&
            wine[key] &&
            wine[key].length > 0 &&
            wine[key].find((item) => item.normalized_note_filtered != '-') &&
            wine[key].find((item) => item.note_type != 'Livrable')
          ) {
            const namesOptions = journalistOptions.map((item) => item.label);
            if (!namesOptions.includes(wine[key][0].journalist_name)) {
              journalistOptions.push({
                value: wine[key][0].journalist_short_name,
                label: wine[key][0].journalist_name,
                order_display: wine[key][0].order_display
              });
            }
          }
        });
      });
      journalistOptions.sort(function (a, b) {
        return Number(a.order_display) - Number(b.order_display);
      });
    }

    return {
      rank: rankOptions,
      journalist: journalistOptions,
      appellation: appellationOptions,
      wine: wineOption
    };
  }

  getDomain(data) {
    const isUnder20 =
      get(data, '[0][0].value') && get(data, '[0][0].value') < 30;
    if (isUnder20) {
      return {
        domain: [10, 20],
        ticks: [10, 12, 14, 16, 18, 20]
      };
    }
    return {
      domain: [80, 100],
      ticks: [80, 85, 90, 95, 100]
    };
  }

  render() {
    const { wine, journalist } = this.state;
    let formattedData = this.formatData();
    const rivals = this.formatRivals(formattedData);

    formattedData = this.removeRivals(formattedData);

    const primeurGraphData = this.filterData(formattedData);
    const options = this.getOptions(formattedData);

    //LINECHARTPROPS
    const rivalsGraph = wine && rivals[wine.value] ? rivals[wine.value] : [];
    const formattedDataChart = this.formatDataChart(
      primeurGraphData || {},
      rivalsGraph
    );
    let labels = [];
    if (formattedDataChart && formattedDataChart.length > 0) {
      formattedDataChart.forEach((set) => {
        if (set.length > 0) {
          let name = set.find((item) => item.wine);
          if (name) {
            labels.push(name.wine);
          }
        }
      });
    }

    const domain = this.getDomain(formattedDataChart);

    return (
      <Container>
        <Card id="evolution-note-primeur">
          {this.renderCardHeader(options.journalist)}
          <div className="filterContainer ignored-export">
            <SelectFilter
              selectedOption={wine}
              onChange={(selectedOption) =>
                this.setState({ wine: selectedOption })
              }
              options={options.wine}
              label={I18n.t('primeur.compare.lineChart.wine')}
            />

            <SelectFilter
              selectedOption={journalist}
              onChange={(selectedOption) =>
                this.setState({ journalist: selectedOption })
              }
              options={options.journalist}
              label={I18n.t('primeur.compare.lineChart.journalist')}
            />
          </div>

          <div className="compareHistoryChartContainer">
            <LineGraph
              height={300}
              data={formattedDataChart}
              labels={labels}
              marginsChart={{ top: 20, right: 20 }}
              yAxisProps={{
                type: 'number',
                domain: domain.domain,
                ticks: domain.ticks
              }}
              type={[
                'linear',
                'linear',
                'linear',
                'linear',
                'linear',
                'linear',
                'linear',
                'linear',
                'linear',
                'linear',
                'linear'
              ]}
              strokeDasharray={[
                null,
                ['5 5'],
                null,
                ['5 5'],
                null,
                ['5 5'],
                null,
                ['5 5'],
                ['5 5'],
                null,
                ['5 5']
              ]}
              colors={[
                '#e25d34',
                '#1f2b37',
                '#273645',
                '#a5aaaf',
                '#B1B7BD',
                '#C9D0D6',
                '#b7bbbf',
                '#dbdddf',
                '#C4C8CC',
                '#D5D9DE',
                '##E1E6EB'
              ]}
            />
          </div>

          {this.renderSelectSets(
            wine && rivals[wine.value] ? rivals[wine.value] : []
          )}
        </Card>
        <Spinner loading={this.state.loading} />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.notes.compare,
    headerCompare: state.notes.headerCompare
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getNotationCompare: async () => {
      await dispatch(getNotationCompare());
    },
    getNotationHeaderCompare: async () => {
      await dispatch(getNotationHeaderCompare());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreparationLineGraph);
